module.exports = __webpack_public_path__ + "img/gb9116_16_d.prt.aba195f7.jpg";